export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  longDescription: string;
  posterUrl: string;
  isNew: boolean;
  isHot: boolean;
  views: number;
}

export const movieCategories = [
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 28 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 22 },
  { name: '剧情', slug: 'drama', icon: 'ri-heart-line', count: 35 },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', count: 18 },
  { name: '科幻', slug: 'scifi', icon: 'ri-rocket-line', count: 25 },
  { name: '动画', slug: 'animation', icon: 'ri-movie-line', count: 20 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line', count: 15 },
  { name: '爱情', slug: 'romance', icon: 'ri-hearts-line', count: 30 },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '时空迷局',
    titleEn: 'Time Maze',
    category: '科幻',
    categorySlug: 'scifi',
    year: 2026,
    rating: 8.7,
    duration: '128分钟',
    director: '张艺谋',
    cast: ['刘德华', '周迅', '黄渤', '章子怡'],
    description: '一位物理学家在实验中意外打开了时空裂缝，穿越到平行宇宙，发现自己必须在72小时内找到回到原本世界的方法，否则两个世界都将毁灭。',
    longDescription: '在量子物理研究所工作的林教授（刘德华饰）在一次粒子对撞实验中，意外打开了连接平行宇宙的时空裂缝。他穿越到了一个看似相同却又截然不同的世界——这里科技更加发达，但他的妻子（周迅饰）并不认识他。在这个陌生的世界里，林教授发现两个宇宙正在相互侵蚀，如果不能在72小时内找到关闭裂缝的方法，两个世界都将面临毁灭。在平行世界的科学家陈博士（黄渤饰）和神秘特工苏琳（章子怡饰）的帮助下，林教授踏上了一段惊心动魄的时空之旅。这是一部融合了硬科幻与人性思考的视觉盛宴，张艺谋导演以其独特的视觉美学，为观众呈现了一个关于选择、爱与牺牲的深刻故事。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20movie%20poster%20with%20time%20travel%20theme%2C%20golden%20warm%20lighting%20portal%20effect%2C%20dramatic%20cinematic%20composition%2C%20clean%20dark%20background%20with%20golden%20accents%2C%20professional%20film%20poster%20design%2C%20minimalist%20aesthetic&width=400&height=560&seq=movie-time-maze-01&orientation=portrait',
    isNew: true,
    isHot: true,
    views: 15800000,
  },
  {
    id: 2,
    title: '暗夜追击',
    titleEn: 'Night Pursuit',
    category: '动作',
    categorySlug: 'action',
    year: 2026,
    rating: 8.4,
    duration: '115分钟',
    director: '陈思诚',
    cast: ['吴京', '张译', '王宝强'],
    description: '前特种兵为保护关键证人，在都市丛林中展开了一场生死时速的追逐战，每一秒都扣人心弦。',
    longDescription: '前特种部队成员陆风（吴京饰）退役后在都市中过着平静的生活，直到一天，一位掌握跨国犯罪集团核心证据的关键证人找到了他。在犯罪集团的疯狂追杀下，陆风必须在都市丛林中保护证人安全抵达法庭。从摩天大楼到地下隧道，从高速公路到废弃工厂，每一秒都是一场生死时速的较量。搭档老刑警（张译饰）和黑客天才（王宝强饰）的加入让这场追击更加惊心动魄。导演陈思诚用紧凑的叙事节奏和令人窒息的追逐场面，打造了一部堪称华语动作片新里程碑的作品。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20urban%20chase%20scene%2C%20night%20cityscape%20neon%20lights%2C%20intense%20dramatic%20lighting%2C%20professional%20film%20poster%20design%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20clean%20composition&width=400&height=560&seq=movie-night-pursuit-02&orientation=portrait',
    isNew: true,
    isHot: true,
    views: 22300000,
  },
  {
    id: 3,
    title: '春日暖阳',
    titleEn: 'Spring Sunshine',
    category: '剧情',
    categorySlug: 'drama',
    year: 2025,
    rating: 9.1,
    duration: '142分钟',
    director: '是枝裕和',
    cast: ['周迅', '易烊千玺', '惠英红'],
    description: '一个关于家庭、记忆与和解的温暖故事。阿春在母亲去世后回到阔别二十年的故乡，发现了母亲留下的秘密。',
    longDescription: '在东京生活了二十年的阿春（周迅饰），在母亲去世后不得不回到她一直逃避的故乡——江南一座小镇。整理母亲遗物时，她发现了一本泛黄的日记，里面记录着母亲从未对她提起的往事。在表弟小杰（易烊千玺饰）和邻居王奶奶（惠英红饰）的陪伴下，阿春开始了一段关于家庭、记忆与和解的旅程。是枝裕和导演以其标志性的细腻笔触，描绘了一幅跨越三代人的中国家庭画卷。影片中每一个细节都充满生活的温度——一碗热汤、一封旧信、一首老歌，都在诉说着关于爱的永恒主题。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20movie%20poster%20with%20warm%20spring%20sunlight%2C%20nostalgic%20gentle%20atmosphere%2C%20soft%20golden%20lighting%2C%20minimalist%20elegant%20composition%2C%20professional%20film%20poster%2C%20emotional%20tone&width=400&height=560&seq=movie-spring-sunshine-03&orientation=portrait',
    isNew: false,
    isHot: true,
    views: 9800000,
  },
  {
    id: 4,
    title: '深海迷踪',
    titleEn: 'Deep Sea Mystery',
    category: '恐怖',
    categorySlug: 'horror',
    year: 2026,
    rating: 7.9,
    duration: '98分钟',
    director: '温子仁',
    cast: ['杨紫琼', '彭于晏', '舒淇'],
    description: '深海科考队在万米海底发现了一个不应该存在的东西，恐惧从深海蔓延到了每个人的心中。',
    longDescription: '国际深海科考队乘坐最先进的潜水器下潜到马里亚纳海沟万米深处，却意外发现了一座不应该存在的神秘建筑。当潜水器开始出现无法解释的故障，队员一个接一个地感受到某种不可名状的恐惧正在逼近，他们意识到——在这片永恒的黑暗中，他们并不孤单。杨紫琼饰演的队长必须带领队员在氧气耗尽前找到逃生的方法，但海底的秘密远超出人类的想象。温子仁导演将恐怖元素与深海科幻完美融合，创造了一种全新的观影体验，让观众在窒息的紧张感中感受来自深渊的恐惧。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20deep%20ocean%20darkness%2C%20mysterious%20underwater%20ruins%2C%20cold%20blue%20and%20dark%20tones%2C%20atmospheric%20tension%2C%20professional%20film%20poster%20design%2C%20cinematic%20composition&width=400&height=560&seq=movie-deep-sea-04&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 6700000,
  },
  {
    id: 5,
    title: '欢乐合伙人',
    titleEn: 'Joyful Partners',
    category: '喜剧',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.2,
    duration: '105分钟',
    director: '徐峥',
    cast: ['沈腾', '马丽', '贾玲', '黄渤'],
    description: '四个性格迥异的人因为一次意外被迫合伙开店，笑料百出中收获了真挚的友情。',
    longDescription: '失业青年大鹏（沈腾饰）、离婚律师安娜（马丽饰）、退休厨师老黄（黄渤饰）和大学生小美（贾玲饰），四个八竿子打不着的人因为一起意外事件被迫合伙经营一家濒临倒闭的餐厅。从互相嫌弃到默契配合，从手忙脚乱到游刃有余，他们在笑料百出的创业路上逐渐找到了人生的方向。徐峥导演用他标志性的喜剧风格，讲述了一个关于梦想、友情和坚持的温暖故事。全片笑点密集但绝不低俗，在让人捧腹大笑的同时，也触动了每个人心中关于生活的那根弦。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20four%20people%20smiling%2C%20bright%20warm%20colors%2C%20restaurant%20background%2C%20playful%20happy%20atmosphere%2C%20professional%20film%20poster%20design%2C%20clean%20minimalist%20style&width=400&height=560&seq=movie-joyful-partners-05&orientation=portrait',
    isNew: true,
    isHot: true,
    views: 31200000,
  },
  {
    id: 6,
    title: '龙族传说',
    titleEn: 'Legend of Dragons',
    category: '动画',
    categorySlug: 'animation',
    year: 2026,
    rating: 8.9,
    duration: '110分钟',
    director: '饺子',
    cast: ['张杰', '周深', '黄龄'],
    description: '少年龙族后裔踏上寻找失落龙珠的冒险旅程，精美的画面和动人的故事让观众沉浸其中。',
    longDescription: '在神秘的东方大陆，少年阿龙（张杰配音）一直以为自己是普通的人类，直到十六岁生日那天，他发现自己竟然是上古龙族最后的血脉。为了阻止黑暗势力复活远古魔龙，阿龙必须找到散落在世界各地的七颗龙珠。在这段充满危险与奇遇的旅程中，他结识了机智的狐妖小九（黄龄配音）和博学的龟仙人（周深配音），三个伙伴一起穿越雪山、沙漠和深海，逐渐揭开了龙族尘封万年的秘密。导演饺子用令人叹为观止的动画技术，打造了一个充满东方美学的奇幻世界。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20dragon%20and%20young%20hero%2C%20oriental%20fantasy%20magical%20atmosphere%2C%20vibrant%20golden%20and%20red%20colors%2C%20epic%20adventure%20theme%2C%20professional%20film%20poster%2C%20clean%20artistic%20style&width=400&height=560&seq=movie-legend-dragons-06&orientation=portrait',
    isNew: true,
    isHot: true,
    views: 45600000,
  },
  {
    id: 7,
    title: '人间世',
    titleEn: 'The Human World',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2025,
    rating: 9.3,
    duration: '95分钟',
    director: '陈晓卿',
    cast: [],
    description: '用镜头记录中国大地上普通人真实生活的纪录片，平凡却震撼人心。',
    longDescription: '导演陈晓卿用两年时间，走遍中国二十三个省份，用镜头记录下普通人最真实的生活状态。从东北的林海雪原到海南的椰林沙滩，从上海的摩天大楼到西藏的雪山脚下，每一帧画面都是一个关于生活的故事。影片中没有剧本，没有演员，只有真实的人和真实的感情。有青藏高原上独自放牧的少年，有深圳工厂里加班的年轻工人，有北京胡同里晒太阳的老人，有云南山区里翻山越岭上学的孩子。这些看似平凡的生活片段，汇聚成了一幅波澜壮阔的当代中国画卷。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20movie%20poster%20with%20ordinary%20people%20real%20life%2C%20warm%20earth%20tones%2C%20natural%20authentic%20atmosphere%2C%20minimalist%20documentary%20style%2C%20professional%20poster%20design%2C%20clean%20composition&width=400&height=560&seq=movie-human-world-07&orientation=portrait',
    isNew: false,
    isHot: false,
    views: 4500000,
  },
  {
    id: 8,
    title: '恋恋时光',
    titleEn: 'Love in Time',
    category: '爱情',
    categorySlug: 'romance',
    year: 2026,
    rating: 8.5,
    duration: '118分钟',
    director: '许鞍华',
    cast: ['刘亦菲', '肖战', '周冬雨'],
    description: '一场跨越十年的爱情故事，两个人在不同的时间点相遇又错过，最终在时光的尽头重逢。',
    longDescription: '2006年的夏天，大学生林小溪（刘亦菲饰）在图书馆邂逅了建筑系学长顾城（肖战饰），两人一见钟情。然而命运却开了个玩笑——顾城获得了去法国深造的机会。此后十年间，他们在巴黎、上海、东京三座城市中不断擦肩而过。林小溪成为了知名摄影师，顾城成为了建筑设计师，各自都有了自己的人生。直到2026年的一次国际设计展上，林小溪的照片和顾城的建筑作品被放在同一个展厅，命运再次将他们拉到了一起。许鞍华导演用她一贯的细腻手法，将一段跨越时空的爱情描绘得如诗如画。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%20with%20couple%20silhouette%2C%20warm%20sunset%20golden%20light%2C%20romantic%20dreamy%20atmosphere%2C%20soft%20elegant%20composition%2C%20professional%20film%20poster%2C%20clean%20minimalist%20design&width=400&height=560&seq=movie-love-in-time-08&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 18900000,
  },
  {
    id: 9,
    title: '烈火英雄',
    titleEn: 'Fire Heroes',
    category: '动作',
    categorySlug: 'action',
    year: 2025,
    rating: 8.0,
    duration: '122分钟',
    director: '林超贤',
    cast: ['彭于晏', '张涵予', '杜江'],
    description: '消防队员们面对史无前例的化工厂大火，用生命守护城市安全的感人故事。',
    longDescription: '一座沿海城市的化工厂突发特大火灾，爆炸引发的连锁反应让整个城市陷入了危机。以队长赵刚（彭于晏饰）为首的消防特勤中队第一时间赶赴现场，却发现这场火灾的规模远超想象。有毒气体蔓延，储油罐随时可能再次爆炸，而厂区内还有数百名工人被困。总指挥张局长（张涵予饰）必须在72小时内控制火势，否则整座城市都将面临毁灭性的灾难。林超贤导演以其擅长的灾难动作片手法，真实还原了消防员面对灾难时的无畏与担当。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20disaster%20movie%20poster%20with%20firefighters%20fighting%20huge%20flames%2C%20intense%20orange%20and%20red%20fire%20lighting%2C%20dramatic%20heroic%20composition%2C%20professional%20film%20poster%2C%20clean%20bold%20design&width=400&height=560&seq=movie-fire-heroes-09&orientation=portrait',
    isNew: false,
    isHot: true,
    views: 27500000,
  },
  {
    id: 10,
    title: '荒野求生',
    titleEn: 'Wild Survival',
    category: '剧情',
    categorySlug: 'drama',
    year: 2026,
    rating: 8.3,
    duration: '135分钟',
    director: '管虎',
    cast: ['易烊千玺', '段奕宏', '谭卓'],
    description: '飞机失事后，一个少年独自在荒野中生存了127天，这是一部关于勇气和希望的史诗。',
    longDescription: '十六岁的少年小北（易烊千玺饰）在乘坐小型飞机前往父亲所在地的途中遭遇空难，成为唯一的幸存者，坠落在一片人迹罕至的原始森林中。没有食物，没有通讯工具，只有随身携带的一把小刀和一个打火机。在接下来的127天里，他必须学会狩猎、辨别方向、躲避野兽，以及与孤独做斗争。而在千里之外，他的父亲（段奕宏饰）和母亲（谭卓饰）从未放弃寻找他的希望。管虎导演用极具震撼力的镜头语言，呈现了一个关于勇气、坚持和生命力的传奇故事。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20survival%20drama%20movie%20poster%20with%20teenager%20in%20wilderness%2C%20vast%20forest%20landscape%2C%20natural%20green%20and%20earth%20tones%2C%20hopeful%20atmosphere%2C%20professional%20film%20poster%2C%20clean%20composition&width=400&height=560&seq=movie-wild-survival-10&orientation=portrait',
    isNew: true,
    isHot: true,
    views: 20100000,
  },
  {
    id: 11,
    title: '星际征途',
    titleEn: 'Star Odyssey',
    category: '科幻',
    categorySlug: 'scifi',
    year: 2025,
    rating: 8.6,
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '李雪健', '刘德华'],
    description: '人类文明面临外星威胁，一支由中国主导的星际舰队肩负起了保卫地球的使命。',
    longDescription: '2087年，人类在火星基地探测到来自遥远星系的神秘信号。科学家们很快意识到这不是自然现象，而是某种高度发达的外星文明的"问候"。当世界各国还在争论如何回应时，由中国人主导建造的"长城"号星际母舰率先出发，踏上了前往未知星域的征途。舰长陆远（吴京饰）、首席科学家陈教授（李雪健饰）和AI指挥官"天眼"（刘德华配音）必须带领船员在星际航行中做出艰难的选择。郭帆导演用宏大的太空场景和严谨的科学设定，打造了一部真正意义上的中国科幻史诗。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20epic%20movie%20poster%20with%20spaceship%20in%20deep%20space%2C%20star%20field%20nebula%20backdrop%2C%20grand%20cosmic%20scale%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20design%2C%20clean%20composition&width=400&height=560&seq=movie-star-odyssey-11&orientation=portrait',
    isNew: false,
    isHot: true,
    views: 38900000,
  },
  {
    id: 12,
    title: '笑傲江湖',
    titleEn: 'Laughing in the Wind',
    category: '喜剧',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.1,
    duration: '100分钟',
    director: '大鹏',
    cast: ['大鹏', '柳岩', '王宝强', '马丽'],
    description: '一群武林高手在现代社会中闹出的各种笑话，古代功夫与现代生活的爆笑碰撞。',
    longDescription: '在古代江湖中威名赫赫的四大高手——剑圣独孤明（大鹏饰）、轻功无双的飞燕（柳岩饰）、力大无穷的金刚（王宝强饰）和暗器大师百花仙子（马丽饰），因为一场意外被传送到了2026年的现代都市。面对手机、地铁、外卖这些现代发明，四位武林高手闹出了一连串令人捧腹的乌龙事件。更糟糕的是，他们必须在七天内找到回去的方法，否则将永远困在现代。大鹏导演将武侠元素与现代喜剧巧妙融合，奉献了一部笑到停不下来的佳作。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20comedy%20movie%20poster%20with%20ancient%20warriors%20in%20modern%20city%2C%20funny%20contrast%20theme%2C%20bright%20vibrant%20colors%2C%20playful%20atmosphere%2C%20professional%20film%20poster%2C%20clean%20design&width=400&height=560&seq=movie-laughing-wind-12&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 13400000,
  },
  {
    id: 13,
    title: '午夜钢琴师',
    titleEn: 'Midnight Pianist',
    category: '恐怖',
    categorySlug: 'horror',
    year: 2025,
    rating: 7.6,
    duration: '92分钟',
    director: '陈正道',
    cast: ['周迅', '朱一龙', '倪妮'],
    description: '一座老宅中的古董钢琴每到午夜就会自动弹奏，揭开了一段被尘封的悲剧往事。',
    longDescription: '音乐教师叶琳（周迅饰）继承了外婆留下的一座老宅，搬进去的第一晚，她就被午夜自动响起的钢琴声惊醒。那是一段她从未听过的旋律，悲伤而诡异。在记者男友小杰（朱一龙饰）和闺蜜小曼（倪妮饰）的帮助下，叶琳开始调查老宅的历史，发现了一段发生在五十年前的骇人悲剧——一位才华横溢的年轻钢琴家在这座宅子中离奇死亡。陈正道导演将心理恐怖与音乐元素巧妙结合，营造出令人毛骨悚然的氛围。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20antique%20piano%20in%20dark%20mansion%2C%20mysterious%20moonlight%20through%20window%2C%20eerie%20atmospheric%20tension%2C%20gothic%20aesthetic%2C%20professional%20film%20poster%2C%20clean%20composition&width=400&height=560&seq=movie-midnight-pianist-13&orientation=portrait',
    isNew: false,
    isHot: false,
    views: 5600000,
  },
  {
    id: 14,
    title: '动物狂欢城',
    titleEn: 'Animal Carnival',
    category: '动画',
    categorySlug: 'animation',
    year: 2026,
    rating: 8.8,
    duration: '95分钟',
    director: '田晓鹏',
    cast: ['杨紫', '王一博', '关晓彤'],
    description: '动物城中一年一度的狂欢节来临，小动物们的奇妙冒险充满了欢笑与感动。',
    longDescription: '在神奇的动物狂欢城中，每年都会举办盛大的狂欢节。今年，小兔子圆圆（杨紫配音）决定参加才艺大赛，但她的"超能力"似乎总是帮倒忙。在好友小狐狸阿飞（王一博配音）和熊猫胖胖（关晓彤配音）的鼓励下，圆圆踏上了寻找真正天赋的旅程。从音乐森林到美食山谷，从星光剧场到彩虹瀑布，一段充满欢笑与感动的冒险就此展开。田晓鹏导演用绚丽的动画和温暖的故事，为全年龄段观众打造了一部治愈系佳作。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20cute%20animals%20at%20carnival%2C%20colorful%20festive%20atmosphere%2C%20bright%20vibrant%20joyful%20colors%2C%20family%20friendly%20theme%2C%20professional%20film%20poster%2C%20clean%20artistic%20style&width=400&height=560&seq=movie-animal-carnival-14&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 25000000,
  },
  {
    id: 15,
    title: '山河故人',
    titleEn: 'Mountains May Depart',
    category: '剧情',
    categorySlug: 'drama',
    year: 2025,
    rating: 8.9,
    duration: '138分钟',
    director: '贾樟柯',
    cast: ['赵涛', '张译', '王景春'],
    description: '三个从小一起长大的朋友，在中国社会巨变的三十年里，各自经历了不同的人生轨迹。',
    longDescription: '1980年代的山西小城，三个年轻人——煤矿工人小军（张译饰）、教师小芳（赵涛饰）和个体户老刘（王景春饰）是最好的朋友。三十年间，中国社会发生了翻天覆地的变化。小军下海经商成为房地产大亨，小芳坚持在教育一线培养了一代又一代学生，老刘则在时代浪潮中起起落落。当他们再次相聚时，已是华发满头。贾樟柯导演用他最擅长的现实主义手法，通过三个普通人的命运变迁，折射出整个中国社会的时代变迁。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20art%20house%20drama%20movie%20poster%20with%20mountain%20landscape%2C%20misty%20nostalgic%20atmosphere%2C%20earthy%20brown%20and%20grey%20tones%2C%20contemplative%20mood%2C%20professional%20film%20poster%2C%20clean%20minimalist%20design&width=400&height=560&seq=movie-mountains-depart-15&orientation=portrait',
    isNew: false,
    isHot: false,
    views: 3200000,
  },
  {
    id: 16,
    title: '东京爱情故事',
    titleEn: 'Tokyo Love Story 2026',
    category: '爱情',
    categorySlug: 'romance',
    year: 2026,
    rating: 8.3,
    duration: '112分钟',
    director: '岩井俊二',
    cast: ['新垣结衣', '彭于晏', '绫濑遥'],
    description: '中国摄影师与日本插画师在东京相遇，一段跨文化的浪漫爱情故事就此展开。',
    longDescription: '中国摄影师陈默（彭于晏饰）为完成一个摄影项目来到东京，在一家古书店偶遇了日本插画师花子（新垣结衣饰）。语言不通的两人通过画笔和照片交流，在东京的大街小巷中留下了无数美好的瞬间。花子的闺蜜美雪（绫濑遥饰）见证了这段跨越文化的感情如何在东京这座城市中生根发芽。然而当项目结束，陈默面临回国还是留下的抉择。岩井俊二导演用他标志性的唯美镜头，将东京的樱花、街道和霓虹灯转化为爱情最浪漫的背景。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Romance%20movie%20poster%20with%20Tokyo%20cityscape%20cherry%20blossoms%2C%20couple%20walking%20under%20pink%20trees%2C%20soft%20romantic%20pastel%20tones%2C%20dreamy%20atmosphere%2C%20professional%20film%20poster%2C%20clean%20elegant%20design&width=400&height=560&seq=movie-tokyo-love-16&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 16500000,
  },
  {
    id: 17,
    title: '大地之歌',
    titleEn: 'Song of the Earth',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2026,
    rating: 9.0,
    duration: '88分钟',
    director: '陆川',
    cast: [],
    description: '从喜马拉雅到南海，从戈壁到雨林，用最美的镜头记录中国大地的壮丽与多样。',
    longDescription: '导演陆川带领摄影团队历时三年，拍摄了中国从最北端的漠河到最南端的曾母暗沙，从世界屋脊青藏高原到东海之滨的壮丽自然景观。影片不仅展现了令人叹为观止的自然美景——珠穆朗玛的日出、九寨沟的彩林、云南石林的奇观、黄山云海的梦幻——更关注了在这片土地上生活的各类生灵，从藏羚羊到中华白海豚，从丹顶鹤到金丝猴。这是一封写给中国大地的情书，每一帧都可以作为壁纸的艺术级纪录片。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20movie%20poster%20with%20majestic%20mountain%20landscape%2C%20golden%20sunrise%20light%2C%20vast%20beautiful%20scenery%2C%20awe%20inspiring%20natural%20beauty%2C%20professional%20film%20poster%2C%20clean%20composition&width=400&height=560&seq=movie-song-earth-17&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 7800000,
  },
  {
    id: 18,
    title: '功夫梦',
    titleEn: 'Kung Fu Dream',
    category: '动作',
    categorySlug: 'action',
    year: 2026,
    rating: 8.0,
    duration: '108分钟',
    director: '成龙',
    cast: ['刘昊然', '成龙', '甄子丹'],
    description: '一个普通少年在功夫大师的指导下，从废柴蜕变为武术冠军的热血励志故事。',
    longDescription: '高中生小明（刘昊然饰）因为体质瘦弱在学校经常被欺负。一次偶然的机会，他认识了社区里开武馆的退役武术冠军老陈（成龙饰）。在老陈的悉心指导下，小明从最基础的站桩开始，一步步学习中国功夫的精髓。然而，当城市武术大赛来临时，小明将面对实力强大的对手——上届冠军的弟子（甄子丹饰）。成龙导演将他几十年的功夫经验融入影片，既有热血沸腾的动作场面，也有感人至深的师徒情谊。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20inspirational%20movie%20poster%20with%20young%20fighter%20training%2C%20warm%20sunset%20dojo%20lighting%2C%20motivational%20spirit%2C%20professional%20film%20poster%20design%2C%20clean%20bold%20composition&width=400&height=560&seq=movie-kungfu-dream-18&orientation=portrait',
    isNew: true,
    isHot: false,
    views: 19300000,
  },
];

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter((m) => m.categorySlug === slug);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getLatestMovies(): Movie[] {
  return movies.filter((m) => m.isNew).slice(0, 8);
}

export function getHotMovies(): Movie[] {
  return movies.filter((m) => m.isHot).slice(0, 6);
}

export function getCategoryName(slug: string): string {
  const cat = movieCategories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}